import { render, staticRenderFns } from "./HomeList.vue?vue&type=template&id=36f7ddea&scoped=true"
import script from "./HomeList.vue?vue&type=script&lang=js"
export * from "./HomeList.vue?vue&type=script&lang=js"
import style0 from "./HomeList.vue?vue&type=style&index=0&id=36f7ddea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f7ddea",
  null
  
)

export default component.exports